(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fellmio-napf-rabatt"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-fnr-form]')) return;
    event.preventDefault();

    var root = form.closest('[data-fnr-root]');
    var fields = form.querySelector('[data-fnr-fields]');
    var success = root.querySelector('[data-fnr-success]');
    var error = form.querySelector('[data-fnr-error]');
    var button = form.querySelector('[data-fnr-submit]');

    error.hidden = true;
    button.disabled = true; var tagsInput = form.querySelector('[data-fnr-tags]'); if (tagsInput) { var picked = ['napf-rabatt']; form.querySelectorAll('input[name="fnr_pet"]:checked').forEach(function (c) { picked.push(c.value); }); tagsInput.value = picked.join(','); }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        var url = response.url || '';
        if (url.indexOf('/challenge') !== -1) {
          // Shopify verlangt eine Captcha-Pruefung: normal absenden.
          form.submit();
          return;
        }
        if (response.ok && url.indexOf('customer_posted=true') !== -1) {
          fields.hidden = true;
          success.hidden = false;
          success.focus({ preventScroll: true });
          success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          setTimeout(function () { error.hidden = false; }, 4000);
        }
      })
      .catch(function () {
        setTimeout(function () { error.hidden = false; }, 4000);
      })
      .then(function () {
        setTimeout(function () { button.disabled = false; }, 4000);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fellmio-willkommen-rabatt"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-fnr-form]')) return;
    event.preventDefault();

    var root = form.closest('[data-fnr-root]');
    var fields = form.querySelector('[data-fnr-fields]');
    var success = root.querySelector('[data-fnr-success]');
    var error = form.querySelector('[data-fnr-error]');
    var button = form.querySelector('[data-fnr-submit]');

    error.hidden = true;
    button.disabled = true; var tagsInput = form.querySelector('[data-fnr-tags]'); if (tagsInput) { var picked = ['willkommen10']; form.querySelectorAll('input[name="fnr_pet"]:checked').forEach(function (c) { picked.push(c.value); }); tagsInput.value = picked.join(','); }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        var url = response.url || '';
        if (url.indexOf('/challenge') !== -1) {
          // Shopify verlangt eine Captcha-Pruefung: normal absenden.
          form.submit();
          return;
        }
        if (response.ok && url.indexOf('customer_posted=true') !== -1) {
          fields.hidden = true;
          success.hidden = false;
          success.focus({ preventScroll: true });
          success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          setTimeout(function () { error.hidden = false; }, 4000);
        }
      })
      .catch(function () {
        setTimeout(function () { error.hidden = false; }, 4000);
      })
      .then(function () {
        setTimeout(function () { button.disabled = false; }, 4000);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
